export default {
  styleOverrides: {
    root: {
      fontSize: 24,
    },
  },
};
